import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

const { carbon } = colorsPalettes;

export const MaximumTextWrapper = styled.div`
    ${setFontVariant("input2", carbon[250])};
`;

export const DropdownFooter = styled(FlexRow)`
    border-top: 1px solid ${carbon[50]};
    justify-content: space-between;
    align-items: center;
    padding: 11px 16px;
`;
